import { useContext } from 'react';
import { AppealContext } from './AppealContext';

export const useAppealContext = () => {
  const context = useContext(AppealContext);

  if (context === undefined) {
    throw new Error('useAppealContext must be used within a AppealContextProvider');
  }

  return context;
};
